// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import CloseIcon from '@mui/icons-material/Close';
import { SortElement } from '../shared/sortable';
import DragHandle from '../shared/drag-handle';
import LayerPickerLayerType from './layer-picker-layer-type';

export default class LayerPickerActiveLayersListItem extends SortElement {
  static propTypes = {
    item: PropTypes.object.isRequired,
    handleLayersClick: PropTypes.func,
  };

  handleClick = () => {
    const { item, handleLayersClick } = this.props;
    handleLayersClick(item);
  };

  render() {
    const { styles } = LayerPickerActiveLayersListItem;
    const { item } = this.props;

    return (
      <div
        className={styles.container}
      >
        <div className={styles.inner}>
          <DragHandle className={styles.dragHandle} />
          <div className={styles.box1}>
            <p className={styles.title}>{item.name}</p>
            <LayerPickerLayerType
              layerType={item.type}
              origin={item.origin}
              fileSize={item.fileSize}
              username={item.esriUsername}
            />
          </div>
          <CloseIcon sx={{ width: 16, cursor: 'pointer' }} onClick={this.handleClick} />
        </div>
      </div>
    );
  }
}

const styles = cssInJS({
  container: {
    fontSize: 12,
    backgroundColor: '#fff',
  },

  inner: {
    borderBottom: '1px solid #eee',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 8,
  },

  title: {
    margin: 0,
    wordBreak: 'break-word',
  },

  description: {
    marginLeft: 4,
    fontSize: 11,
  },

  dragHandle: {
    display: 'flex',
  },

  box1: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
});

LayerPickerActiveLayersListItem.styles = styles;
